module.exports = {
  email: 'srishti.arora72@gmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/srishtii1',
    },

    {
      name: 'Twitter',
      url: 'https://twitter.com/srishtiarora__',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/srishti--arora',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'News',
      url: '/#news',
    },
    {
      name: 'Research',
      url: '/#research',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Awards',
      url: '/#awards',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Skills',
      url: '/#skills',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#64ffda',
    forestGreen: '#228B22',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
